
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useCurrentUserEmail = (primaryEmail: string, onPrimaryEmailChange: (email: string) => void) => {
  const [currentUserEmail, setCurrentUserEmail] = useState<string>("");

  useEffect(() => {
    const getCurrentUserEmail = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user?.email) {
        setCurrentUserEmail(user.email);
        if (!primaryEmail) {
          onPrimaryEmailChange(user.email);
        }
      }
    };
    getCurrentUserEmail();
  }, [primaryEmail, onPrimaryEmailChange]);

  return currentUserEmail;
};
